<style>
    @import '~instantsearch.css/themes/algolia.css';
</style>
<style lang="scss" src="../../sass/ais-search.scss"></style>

<template>
    <ais-instant-search
        :search-client="searchClient"
        :search-function="searchMethod"
        :index-name="searchIndex"
        :routing="routing">

        <div class="left-panel">
            <div class="d-flex">
                <div class="pr-2 py-0 my-0">
                    <ais-menu-select attribute="obj_type">
                        <template slot="defaultOption">Search Everything</template>
                    </ais-menu-select>
                </div>
                <div class="flex-fill py-0 my-0">
                    <ais-search-box>
                        <div slot-scope="{ currentRefinement, isSearchStalled, refine }">
                            <input
                                type="search"
                                autocorrect="off"
                                autocapitalize="off"
                                spellcheck="false"
                                required="required"
                                maxlength="512"
                                aria-label="Search"
                                placeholder="Search here..."
                                class="ais-SearchBox-input"
                                v-model="currentRefinement"
                                @input="refine($event.currentTarget.value)"
                            />
                            <span :hidden="!isSearchStalled">Loading...</span>
                        </div>
                    </ais-search-box>
                </div>
            </div>

            <div class="d-flex">
                <div class="flex-fill">
                    <ais-current-refinements :transform-items="transformSearchCriteriaLabels" :excluded-attributes="['date_pub']" />
                </div>
                <div class="pr-2">
                    <ais-clear-refinements :excluded-attributes="['date_pub']" >
                        <span slot="default" slot-scope="{ canRefine, refine, createURL }">
                            <a :href="createURL()" @click.prevent="refine" v-if="canRefine" nowrap="nowrap">Reset&nbsp;Filters</a>
                        </span>
                    </ais-clear-refinements>
                </div>
            </div>

            <ais-infinite-hits>
                <div slot-scope="{ items, refineNext }" class="list-unstyled">
                    <div v-for="item in items" :key="item.objectID">
                        <a
                            :href="item.uri"
                            class="media py-2 border-bottom hover-highlight">
                            <img :src="item.image" :alt="item.title"
                                class="mr-3 img-thumbnail align-self-start" style="width: 200px;" />
                            <div class="media-body">
                                <span class="badger">
                                    {{ item.obj_type }}
                                </span>
                                <h5 class="mt-0 mb-1">
                                    <ais-highlight attribute="title" :hit="item" />
                                    <br/>
                                    <small>
                                        <span class="pub-date" v-if="item.obj_type == 'Event'">{{ item.date_pub | friendlyDateFromTimestamp }}</span>
                                        <span class="pub-date" v-if="item.obj_type == 'Article' ||
                                                    item.obj_type == 'Paywall' ||
                                                    item.obj_type == 'Slides' ||
                                                    item.obj_type == 'Video' ||
                                                    item.obj_type == 'Library Item'">Published {{ item.date_pub | relativeDateFromTimestamp }}</span>
                                    </small>
                                </h5>
                            </div>
                        </a>
                    </div>
                    <div class="text-center px-auto mt-5">
                        <button @click="refineNext">Get More Search Results</button>
                    </div>
                </div>
            </ais-infinite-hits>
            <ais-stats class="text-center" />
        </div>

        <div class="right-panel">
            <div id="facets">
            </div>
            <ais-configure :hitsPerPage="24" />

        </div>

    </ais-instant-search>
</template>

<script>
    import algoliasearch from 'algoliasearch/lite';
    import { history as historyRouter } from 'instantsearch.js/es/lib/routers';
    import { simple as simpleMapping } from 'instantsearch.js/es/lib/stateMappings';
    import moment from 'moment';

    export default {
        data() {
            var index = '';
            if(process.env.MIX_APP_ENV == 'production'){
                index = 'unified_search';
            }else{
                index = process.env.MIX_APP_ENV + '_unified_search';
            }
            // console.log(index);
            return {
                searchClient: algoliasearch(
                    process.env.MIX_ALGOLIA_APP_ID,
                    process.env.MIX_ALGOLIA_SEARCH_SECRET
                ),
                searchIndex: index,
                routing: {
                    router: historyRouter(),
                    stateMapping: simpleMapping(),
                }
            };
        },
        filters: {
            relativeDateFromTimestamp: function (value) {
                if (value) {
                    return moment.unix(value).fromNow();
                }
            },
            friendlyDateFromTimestamp: function (value) {
                if (value) {
                    return moment.unix(value).format("LL");
                }
            }
        },
        methods: {
            transformSearchCriteriaLabels: function (items){
                    let map = {
                        'title': "Title",
                        'name' : "Name",
                        'obj_type': "Content Type",
                        'obj_subtype': "Refinement",
                        'tag_brands.name': "Brands",
                        'tag_subjects.name': "Subjects",
                        'tag_people.name': "People",
                        'tag_events.name': "Events",
                        'tag_sdgs.name': "SDGs",
                    };
                    for (var i=0; i<items.length; i++) {
                        var key = items[i].attribute;
                        if (key in map) {
                            items[i].label = map[key];
                        }
                    }
                    return items;
                },
            searchMethod(helper) {
                if (helper.state) {
                    const page = helper.getPage();
                    helper.setPage(page).search();
                }
            }
        }
    }

</script>
